/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Footer_DpaInputs */

const da_forside_footer_dpa = /** @type {(inputs: Forside_Footer_DpaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Databehandleraftale og liste over underdatabehandlere er endnu ikke offentliggjort.`)
};

/** @type {(inputs: Forside_Footer_DpaInputs) => LocalizedString} */
const en_forside_footer_dpa = da_forside_footer_dpa;

/**

* @param {Forside_Footer_DpaInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_footer_dpa = /** @type {((inputs?: Forside_Footer_DpaInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Footer_DpaInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_footer_dpa(inputs)
	return /** @type {LocalizedString} */ ("Databehandleraftale og liste over underdatabehandlere er endnu ikke offentliggjort.")
});